import { useContext, useDebugValue } from "react";
import AuthContext from "../context/AuthProvider";

const useAuth = () => {
    const { auth } = useContext(AuthContext) as AuthContext;
    useDebugValue(auth, auth => auth.data ? "Logged in" : "Logged out");
    return useContext(AuthContext) as AuthContext
}

export default useAuth;